enum LANGUAGES {
    ENGLISH = 'en',
    GERMAN = 'de'
}

export default LANGUAGES
